export default "__VITE_ASSET__a04869b0__"